import { render, staticRenderFns } from "./profile-form-page.vue?vue&type=template&id=4fd10210&scoped=true&"
import script from "./profile-form-page.vue?vue&type=script&lang=js&"
export * from "./profile-form-page.vue?vue&type=script&lang=js&"
import style0 from "./profile-form-page.vue?vue&type=style&index=0&id=4fd10210&lang=scss&scoped=true&"
import style1 from "./profile-form-page.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd10210",
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl,QForm,QInput,QBtn,QSpinnerIos,QField} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl,QForm,QInput,QBtn,QSpinnerIos,QField})
